// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewlabel {
  max-width: 200px;
}

.view-value {
  width: calc(100% - 200px);
}`, "",{"version":3,"sources":["webpack://./src/app/common/submit/submit.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AACA;EACI,yBAAA;AAEJ","sourcesContent":[".viewlabel{\r\n    max-width: 200px;\r\n}\r\n.view-value{\r\n    width: calc(100% - 200px);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
